import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../constants';

/**
 * Hook to detect mobile screen size
 * @param breakpoint - Width threshold in pixels (default: BREAKPOINTS.MOBILE)
 * @returns boolean indicating if screen is mobile-sized
 */
export const useIsMobile = (breakpoint: number = BREAKPOINTS.MOBILE): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
